import classNames from 'classnames';
import React from 'react';
import type { Placement } from '@floating-ui/react-dom';
import PopOverPrimitive from '../components/PopOverPrimitive';
import styles from './ControlBarPopOver.module.scss';

const OFFSET = 14;
const SCREEN_PADDING = 12;

interface ControlBarPopOverProps {
  children: React.ReactNode;
  content: React.ReactNode;
  open: boolean;
  placement: Placement;
  onOpenChange: (open: boolean) => void;
  hide?: boolean;
}

const ControlBarPopOver = ({
  content,
  open,
  children,
  placement,
  onOpenChange,
  hide,
}: ControlBarPopOverProps) => {
  return (
    <PopOverPrimitive
      onOpenChange={onOpenChange}
      open={open}
      offset={OFFSET}
      namespace="controlBar"
      screenPadding={SCREEN_PADDING}
      placement={placement}
      trigger="click"
      autoUpdateAnimationFrame
      noFlip
      hideWhenReferenceHidden
    >
      <PopOverPrimitive.Trigger asChild>{children}</PopOverPrimitive.Trigger>

      {!hide && (
        <PopOverPrimitive.Floating>
          <PopOverPrimitive.Content className={styles.inner}>
            {content}
          </PopOverPrimitive.Content>

          <PopOverPrimitive.Arrow
            height={10}
            width={18}
            offset={2}
            viewBox="0 0 18 10"
          >
            <path
              className={styles.arrowBg}
              d="M9.95385 1.71898L17 9L1 9L8.53945 1.69616C8.93627 1.31174 9.56964 1.32196 9.95385 1.71898Z"
            />
            <path
              className={classNames(styles.arrowBg, styles.arrowStroke)}
              d="M17 9L9.95385 1.71898C9.56964 1.32196 8.93627 1.31174 8.53945 1.69616L1 9"
            />
            <rect
              className={styles.arrowBg}
              x="18"
              y="9"
              width="1"
              height="18"
              transform="rotate(90 18 9)"
            />
          </PopOverPrimitive.Arrow>
        </PopOverPrimitive.Floating>
      )}
    </PopOverPrimitive>
  );
};

ControlBarPopOver.Anchor = PopOverPrimitive.Anchor;

export default ControlBarPopOver;
